import { useState , useEffect} from 'react';
import axios from 'axios';

export const useFetchHome = () => {
    const [homeList, setHomeList] = useState([]);
    const [isLoadingHome , setIsLoading] = useState(false);
    //const [isError , setIsError] = useState(false);
    
    useEffect(() => {
        const fetchRequest = async ()  =>{
            setIsLoading(true);

            //JSON取得
            axios.get('/assets/json/homeData.json?'+(new Date()).getTime())
                .then(res => {
                    const data = JSON.parse(JSON.stringify(res.data));
                    setHomeList(data);
                })
                //.catch(() => setIsError(true))
                .finally(() => setIsLoading(false));
        }
        fetchRequest();
    }, []); 

    return {homeList , isLoadingHome };
}
